import { CurriculumType } from "@/util/enum";
import { GLServiceBase, ServiceRoute } from "commonui";
import { IConversationMasterBuilderService, CompExpConvMasterModel } from ".";

class ConversationMasterBuilderServiceClass extends GLServiceBase<any, any>
	implements IConversationMasterBuilderService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/conversations/master" };

	getMasterData(
		unitId: number | string,
		versionGroupId: string,
		curriculumType: CurriculumType,
		lessonPlanVersionId: string
	): Promise<CompExpConvMasterModel[]> {
		return this.get(
			"units/{unitId}/{lessonPlanVersionId}/versiongroups/{versionGroupId}/license/{curriculumType}",
			{
				unitId,
				lessonPlanVersionId,
				versionGroupId,
				curriculumType
			}
		);
	}
}

export const ConversationMasterBuilderService: IConversationMasterBuilderService = new ConversationMasterBuilderServiceClass();
